export const LABEL_POSITION = {
  TOP: 'top',
  RIGHT: 'right',
  LEFT: 'left'
};